import React from 'react';
import recommendedSearches, {
  RecommendedLink
} from './recommendedSearchesList';
import { priceDropRestrictedStates } from '../../../constants';
import { useInputContext } from '../../../context/InputContext';
import DefaultSuggestionClicked from '../../../contracts/DefaultSuggestionClicked';
import { useSearchBarContext } from '../../../SearchBarContext';
import {
  modalStyles,
  SectionContent,
  SectionTitle,
  SuggestionLinkText,
  SuggestionLinkWrapper,
  SuggestionSectionContainer
} from '../DefaultSuggestions.styles';

type OwnProps = {
  handleDefaultSuggestionClicked: DefaultSuggestionClicked;
  inModal?: boolean;
};

export default function DefaultRecommended({
  handleDefaultSuggestionClicked,
  inModal
}: OwnProps) {
  const { inputValue } = useInputContext();
  const { geolocationState } = useSearchBarContext();
  const isRestrictedState =
    priceDropRestrictedStates.includes(geolocationState);

  return (
    <SuggestionSectionContainer>
      <SectionTitle className={inModal ? 'pl-16' : ''}>
        Recommended
      </SectionTitle>
      <div className={inModal ? modalStyles : ''}>
        <SectionContent className={inModal ? 'min-w-[500px]' : ''}>
          {recommendedSearches(isRestrictedState).map(
            (recommended: RecommendedLink) => (
              <SuggestionLinkWrapper
                data-analytics-id="Default Suggestions"
                data-analytics-attributes={JSON.stringify({
                  category: 'Recommended',
                  label: recommended.text,
                  textEntered: inputValue
                })}
                data-qa="Default Search Recommended"
                defaultSuggestion={recommended}
                handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
                key={recommended.text}
              >
                {recommended?.icon && recommended.icon}
                <SuggestionLinkText>{recommended.text}</SuggestionLinkText>
              </SuggestionLinkWrapper>
            )
          )}
        </SectionContent>
      </div>
    </SuggestionSectionContainer>
  );
}
